<template>
  <section class="table">
    <template v-if="!csHome">
      <el-table
        :show-header="showHeader"
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="69"
          align="center">
          <template>
            <font-awesome-icon
              icon="dollar-sign"
              class="icon"/>
          </template>
        </el-table-column>

        <el-table-column
          prop="quote_dt"
          width="95"
          label="Created">
          <template #default="{ row }">
            <div class="time-text">
              <span>{{ row.quote_dt.split(" ")[0] }}</span>
              <span> {{ row.quote_dt.split(" ")[1] }}</span>
            </div>
            <p class="channel">{{row.source_language}}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Plan">
          <template #default="{ row }">
            <div class="plan">
              <div class="status-icon">
                <span class="button-border">{{row.type_language}}</span>
                <div class="company-icon">
                  <span
                    v-if="row.company_id"
                    v-tooltip="row.company_language"
                    class="icon"
                  >
                    <img
                      :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                    >
                  </span>
                  <span>
                    <span
                      v-tooltip="row.class_language"
                      class="icon"
                    >
                      <font-awesome-icon
                        v-if="row.class_id&& row.product_id!==80"
                        :icon="getOptionName('iconOptions', row.class_id)" />
                      <font-awesome-icon
                        v-else
                        icon="cube" />
                    </span>
                  </span>
                </div>
              </div>
              <div class="plan-info">
                <router-link
                  class="showLink"
                  :to="rowClickFn(row)">
                  {{ row.plan }}
                </router-link>
                <p  class="liter-text">{{row.quotation_number}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="price"
          label="Price">
          <template #default="{ row }">
            <div class="price">
              <span>${{row.price}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="policy_period"
          label="Period"></el-table-column>
        <el-table-column
          prop="stts_language"
          width="200"
          label="Status">
          <template #default="{ row }">
            <div class="status">
              <span>
                <span
                  class="span-status"
                  :class="{
                    'yellow-dark': [4, 7].includes(row.stts),
                    'blue': [1, 5].includes(row.stts),
                    'red': [6].includes(row.stts),
                    'purple': [3].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </span>
              <span
                v-for="(v,i) in row.tag_language"
                :key="i">
                <span
                  class="span-options"
                  :class="{
                    'red': [1].includes(v.id),
                    'gray': [2,4].includes(v.id)
                  }">
                  {{ v.name }}
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-else>
      <el-table
        :show-header="showHeader"
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="40"
          align="center">
          <template>
            <div class="flex-algin ">
              <span >
                <font-awesome-icon icon="dollar-sign" />
              </span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="quote_dt"
          width="100"
          label="Created">
          <template #default="{ row }">
            <div class="text">
              <span>{{ row.quote_dt.split(" ")[0] }}</span><br>

              <span> {{ row.quote_dt.split(" ")[1] }}</span>
              <p class="channel">{{row.source_language}}</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="85"
          prop="id"
        >
          <template #default="{ row }">
            <span class="button-border table-type">{{row.type_language}}</span>
            <div
              class="flex-center margin-top-flex"
              :class="{'ju_center': row.company_id == 0}">
              <span
                v-if="row.company_id&&row.product_id!=80"
                v-tooltip="row.company_language"
                class="icon icon-content"
              >
                <img
                  :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
                >
              </span>
              <span>
                <span
                  v-tooltip="row.class_language"
                  class="icon icon-content"
                >
                  <font-awesome-icon
                    v-if="row.class_id&&row.product_id!=80"
                    :icon="getOptionName('iconOptions', row.class_id)" />
                  <font-awesome-icon
                    v-else
                    icon="cube" />
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="180"
          label="Plan Name">
          <template #default="{ row }">
            <div class="plan">
              <div
                class="plan-info"
                @click="rowClick(row)">
                <router-link
                  class="showLink"
                  :to="rowClickFn(row)">
                  {{ row.plan }}
                </router-link>
                <p  class="liter-text">{{row.quotation_number}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="85"
          prop="price"
          label="Price">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>{{row.price}}</span>
              <p></p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="120"
          prop="contact_nm"
          label="Account">
          <template #default="{ row }">
            <div class="flex-algin">
              <span>
                {{ row.contact_nm }}
              </span>
              <p  class="liter-text"> {{ row.phone_no }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="110"
          prop="referrer_nm"
          label="Referrer"></el-table-column>
        <el-table-column
          width="100"
          label="Period">
          <template #default="{row}">
            <div
              v-if="row.policy_period"
              class="flex-column">
              <span>{{row.policy_period.split(" - ")[0]}} - </span>
              <span>{{row.policy_period.split(" - ")[1]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          prop="stts_language"
          label="Status">
          <template #default="{ row }">
            <div class="status">
              <span>
                <span
                  class="span-status"
                  :class="{
                    'yellow-dark': [4, 7].includes(row.stts),
                    'blue': [1, 5].includes(row.stts),
                    'red': [6].includes(row.stts),
                    'purple': [3].includes(row.stts)
                  }">
                  {{ row.stts_language }}
                </span>
              </span>
              <span
                v-for="(v,i) in row.tag_language"
                :key="i">
                <span
                  class="span-options"
                  :class="{
                    'red': [1].includes(v.id),
                    'gray': [2,4].includes(v.id)
                  }">
                  {{ v.name }}
                </span>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <v-pagination
      v-if="showHeader"
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getOrderList} from '@/api/order'
import MixinOptions from '@/mixins/options'

export default {
  name: 'QuoteTable',
  mixins: [MixinOptions],
  props:{
    customerId:{
      type: [String,Number],
      default: null
    },
    showHeader:{
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 20
    },
    filters: {
      type: Object,
      default: () => {}
    },
    csHome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageConfig: {
        currentPage: 1,
        total: 10
      },
      tableData: [],
    }
  },
  watch:{
    customerId:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getOrderList()
        }
      }
    },
    csHome:{
      immediate: true,
      handler(val){
        if(val){
          this.network().getOrderList()
        }
      }
    }
  },
  methods: {
    rowClick(row) {
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id
        }
      })
    },
    // 新标签打开链接
    rowClickFn(row){
      return({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getOrderList()
    },
    network() {
      return {
        getOrderList: async () => {
          const { data } = await getOrderList({
            page: this.pageConfig.currentPage,
            size: this.size,
            customer_id: this.customerId,
            ...this.filters
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.table {
  .icon{
    font-size: 14px;
  }
  .time-text{
    font-size: 12px;
    display: flex;
    flex-direction: column;
  }
  .channel{
    font-size: 12px;
    font-weight: 600;
    color: #586069;
    margin: 5px 0;
    height: 18px;
    line-height: 18px;
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gray {
      border-color: #586069;
      color: #586069;
    }
  }
  .table-type{
    white-space: nowrap;
  }
  .margin-top-flex{
    margin-top: 5px;
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
  }
  .ju_center{
    justify-content: center;
  }
  .plan{
    .status-icon{
      display: flex;
      .button-border{
        display: inline-block;
        padding: 0px 10px;
        height: auto;
        font-size: 12px;
        color: #24292E;
        margin-right: 10px;
        background: #FFFFFF;
        border: 1px solid #6A737D;
        border-radius: 100px;
        font-weight: 600;
        line-height: 18px;
        height: 18px;
      }
      .company-icon{
        display: flex;
        .icon{
          margin-right: 8px;
          height: 22px;
          width: 22px;
          border-radius: 5px;
          background-color: #E1E4E8;
          color: #6A737D;
          font-size: 14px;
          text-align: center;
          line-height: 22px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #e1e4e8;
          img{
            height: 22px;
            width: 22px;
          }
        }
      }
    }
    .plan-info{
      .showLink{
        text-decoration: none;
        font-weight: 600;
        font-size: 12px;
        color: #24292E;
        &:hover{
          color:  #0366D6;
        }
      }
      .liter-text{
        color: #6A737D;
        font-size: 12px;
      }
    }
  }
  .price{
    color: #24292E;
    font-size: 12px;
  }
  .status{
  .span-status, .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    height: 18px;
    min-height: 18px !important;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
    &.purple {
      background: #6F42C1;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  }
}
/deep/ .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
     .cell{
       line-height: 23px;
       position: relative;
       height: inherit;
       padding: 0;
     }
    }
  }
  tbody{
    font-size: 12px;
  }
  .table-pointer{
    cursor: pointer;
  }
}
/deep/ .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
}
</style>
